<template>
  <div class="img-preview" :title="title" @click="openImage">
    <img class="img-preview__img" :src="src" :alt="alt" />
    <svg-icon class="img-preview__icon" icon-name="search"></svg-icon>
  </div>
</template>

<script>
import { openImage } from "@/components/common/ImageModal";

export default {
  name: "ImgPreview",
  props: {
    src: String,
    alt: String,
    title: String
  },

  methods: {
    openImage() {
      const { src, alt, title } = this;
      openImage({
        src,
        alt,
        title
      });
    }
  }
};
</script>

<style lang="scss">
.img-preview {
  border: 1px solid colors(palette-3);
  font-size: 13px;
  cursor: pointer;
  position: relative;

  &__img {
    display: block;
    width: 100%;
    height: 100%;
  }

  &__icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.2);
    opacity: 0;
    transition: 0.3s;
    filter: drop-shadow(0 0 5px #000);
  }

  &:hover & {
    &__icon {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }
}
</style>
